import React from 'react';

import { Select as ChakraSelect, SelectProps } from '@chakra-ui/react';

type Props<T> = Omit<
  SelectProps,
  'value' | 'onChange' | 'width' | 'maxWidth'
> & {
  options: Array<T> | ReadonlyArray<T>;
  value?: T;
  isSelected?: (value: T) => boolean;
  getLabel?: (value: T) => string;
  onChange?: (value: T, index: number) => void;
  width?: number | 'auto';
  maxWidth?: number | 'auto';
};

export function Select<T>(props: Props<T>) {
  let {
    options,
    value,
    isSelected,
    getLabel,
    onChange,
    rootProps,
    width,
    maxWidth,
    style,
    ...otherProps
  } = props;
  let check = isSelected ?? ((item) => item === value);
  let selectedIndex = 0;
  let children = options.map((value, i) => {
    if (check(value)) {
      selectedIndex = i;
    }
    return (
      <option key={i} value={String(i)}>
        {getLabel ? getLabel(value) : String(value)}
      </option>
    );
  });
  return (
    <ChakraSelect
      {...otherProps}
      rootProps={{
        ...rootProps,
        style: { width, maxWidth, ...rootProps?.style },
      }}
      style={{ width, maxWidth, ...style }}
      value={String(selectedIndex)}
      onChange={(event) => {
        // We could probably use event.target.selectedIndex here
        let index = Number(event.target.value);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        let value = options[index]!;
        onChange?.(value, index);
      }}
    >
      {children}
    </ChakraSelect>
  );
}
